import Conf from 'ui-config'
import axios from 'axios'

export async function Auth_init(params) {
  return await axios(Conf.HOST + Conf.LC_IP + '/lc/users/init', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(params),
  })
}

export async function Auth_login(params) {
  return await axios(Conf.HOST + Conf.LC_IP + '/lc/users/login', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(params),
  })
}

export async function Verify_OTP(params) {
  return await axios(Conf.HOST + Conf.LC_IP + '/lc/users/verify-otp', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(params),
  })
}

export async function Auth_currentAccount() {
  var payload = JSON.parse(localStorage.getItem('payload'))
  return payload
}

export async function Auth_logout(params) {
  return await axios(Conf.HOST + Conf.LC_IP + '/lc/users/logout', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      SSID: params.ssid,
    },
    data: params,
  })
}

export async function Auth_invalidate(params) {
  return await axios(
    // Conf.HOST_S + Conf.CORE_IP + '/api/session/invalidate',
    Conf.HOST_S + Conf.CORE_IP + '/' + params.clusterId + '/api/session/invalidate',
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        SSID: params.SSID,
      },
      data: {},
    },
  )
}
